import type { Components, Theme } from "@mui/material/styles";
import { RadiusToken } from "../../tokens/radii";

export const MuiOutlinedInput: NonNullable<
  Components<Theme>["MuiOutlinedInput"]
> = {
  styleOverrides: {
    root: ({ theme }) => {
      const rmh = theme.vars!.palette.rmh;
      return {
        borderRadius: RadiusToken.MD,
        "& .MuiOutlinedInput-input": {
          ...theme.typography.bodyMdRegular,
          "&::placeholder": theme.typography.bodyMdRegular,
        },
        "&.MuiInputBase-adornedStart .MuiOutlinedInput-input": {
          paddingLeft: 0,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: RadiusToken.MD,
          borderColor: rmh.border["1-surface"].rest,
          borderWidth: theme.spacing(0.25),
          transition: theme.transitions.create(
            ["border-color", "border-width"],
            { duration: theme.transitions.duration.shortest }
          ),
        },
        transition: theme.transitions.create(
          ["background-color", "box-shadow"],
          { duration: theme.transitions.duration.shortest }
        ),
        backgroundColor: rmh.paper["1-surface"].rest,
        "&:hover:not(.Mui-disabled, .Mui-focused, .Mui-error) .MuiOutlinedInput-notchedOutline":
          {
            borderColor: rmh.border["4-faint"].hover,
          },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: rmh.border["5-brand"].rest,
          borderWidth: theme.spacing(0.375),
        },
        "&.Mui-error .MuiOutlinedInput-notchedOutline": {
          borderColor: rmh.border["8-error"].rest,
          borderWidth: theme.spacing(0.25),
        },
        "&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline": {
          borderColor: rmh.border["8-error"].rest,
          borderWidth: theme.spacing(0.375),
        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          borderColor: rmh.stateBorder.disabled,
          borderWidth: theme.spacing(0.25),
        },
        "&.Mui-disabled": {
          backgroundColor: rmh.stateBackground.disabledInput,
        },
        "&.Mui-focused:not(.Mui-error)": {
          boxShadow: rmh.focus.primary,
        },
        "&.Mui-focused.Mui-error": {
          boxShadow: rmh.focus.error,
        },
      };
    },
  },
  variants: [
    {
      props: { size: "small" },
      style: ({ theme }) => ({
        "& .MuiOutlinedInput-input": {
          padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
          gap: theme.spacing(2),
        },
        "&.MuiInputBase-multiline": {
          padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
        },
        "&.MuiInputBase-multiline .MuiOutlinedInput-input": {
          padding: 0,
        },
      }),
    },
    {
      props: { size: "medium" },
      style: ({ theme }) => ({
        "& .MuiOutlinedInput-input": {
          padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
          gap: theme.spacing(2),
        },
        "&.MuiInputBase-multiline": {
          padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
        },
        "&.MuiInputBase-multiline .MuiOutlinedInput-input": {
          padding: 0,
        },
      }),
    },
  ],
};
